import i18n from '@/plugins/i18n'

export default [
  // VBP
  {
    path: 'projectCalendar',
    name: 'ProjectCalendar',
    component: () => import('./PgCalendar.vue'),
    portalGroup: 'collab.my',
    meta: { authenticated: true, title: i18n.t('l0101.calendar.title') }
  }
]
